<form [formGroup]="form" novalidate class="d-flex flex-column gap-3">
  <gstar-countries-combobox
    [value]="countryValue"
    [disabled]="isEdit"
    (clearCountry)="countryClear()"
    (selectCountry)="countrySelect($event)"
    [title]="'residencyJurisdiction.country' | translate" />
  @if (countryField.errors?.['required']) {
    <div class="ap-field-validation-error">
      {{ 'formValidations.required' | translate }}
    </div>
  }
  <ap-field
    [title]="'residencyJurisdiction.region' | translate"
    [disabled]="true">
    <input appkit-field formControlName="region" />
  </ap-field>

  <ap-checkbox formControlName="isActive" class="mt-2">
    {{ 'residencyJurisdiction.isActive' | translate }}
  </ap-checkbox>
</form>
